import { generatePassword } from '../../helpers/mixins'
import { axiosInstance } from '@/plugins/axios'

const api = axiosInstance

export default {
  namespaced: true,
  state: {
    dialog: false,
    isSaving: false,
    activeVendor: null,
    linkedUser: '',
    dialogType: 0,
    activeDialog: '',
    createItem: {},
    entitiesLoading: false,
    devicesLoading: false,
    usersLoading: false,
    subVendor: null,
    selectedDevices: [],
    selectedEntities: [],
    selectedUsers: [],
    vendorEntities: [],
    vendorDevices: [],
    vendorUsers: []
  },
  mutations: {
    setEntitiesLoading (state, { status }) {
      state.entitiesLoading = status
    },
    setDevicesLoading (state, { status }) {
      state.devicesLoading = status
    },
    setActiveVendor (state, { vendor }) {
      if (typeof vendor === 'object') {
        state.activeVendor = vendor[0]
      }
    },
    setUsersLoading (state, { status }) {
      state.usersLoading = status
    },
    resetSelected (state) {
      state.selectedDevices = []
      state.selectedEntities = []
      state.selectedUsers = []
    },
    selectEntity (state, { entity }) {
      state.selectedEntities.push(entity)
    },
    setSelectedEntities (state, { entities }) {
      state.selectedEntities = entities
    },
    closeDialog (state) {
      state.dialogType = 0
      state.linkedUser = ''
      state.isSaving = false
      state.dialog = false
    },
    enableResponseDialog (state, { type, commit }) {
      state.activeDialog = type
      commit('closeDialog')
      setTimeout(() => { commit('closeResponseDialog') }, 6000)
    },
    closeResponseDialog (state) {
      state.activeDialog = ''
    },
    setIsSaving (state) {
      state.isSaving = true
    },
    setSubVendor (state, { subVendor }) {
      state.subVendor = subVendor
    },
    setLinkedUser (state, { userId }) {
      state.linkedUser = userId || null
    },
    openDialog (state) {
      state.dialog = true
    },
    setUserDialog (state) {
      state.dialogType = 0
      state.activeDialog = 'link:user'
      state.createItem = {}
    },
    setDeleteVendorDialog (state) {
      state.dialogType = 0
      state.activeDialog = 'delete:vendor'
    },
    setLinkVendorDialog (state) {
      state.dialogType = 0
      state.activeDialog = 'link:vendor'
      state.createItem = {}
    },
    setCreateVendorDialog (state) {
      state.dialogType = 0
      state.activeDialog = 'create:business'
      state.createItem = {
        name: '',
        address: '',
        postcode: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        parent: state.activeVendor
      }
    },
    setUpdateVendorDialog (state, { parentVendor }) {
      state.dialogType = 1
      state.activeDialog = 'create:business'
      state.createItem = {
        id: state.activeVendor.id,
        name: state.activeVendor.name,
        address: state.activeVendor.address,
        postcode: state.activeVendor.postcode,
        city: state.activeVendor.city,
        country: state.activeVendor.country,
        email: state.activeVendor.email,
        phone: state.activeVendor.phone,
        parent: parentVendor
      }
    },
    setCreateUserDialog (state) {
      state.dialogType = 0
      state.activeDialog = 'create:user'
      state.createItem = {
        first_name: '',
        last_name: '',
        address: '',
        postcode: '',
        city: '',
        phone: '',
        email: '',
        role_name: '',
        parent: state.activeVendor,
        password: generatePassword()
      }
    },
    setDefaultParentVendor (state, { vendor }) {
      state.createItem.parent = vendor
    },
    stopSaving (state) {
      state.isSaving = false
    },
    setPassword (state, { password }) {
      state.createItem.password = password
    },
    setVendorEntities (state, { entities }) {
      state.vendorEntities = entities
    },
    setVendorUsers (state, { users }) {
      state.vendorUsers = users
    },
    setVendorDevices (state, { devices }) {
      state.vendorDevices = devices
    }
  },
  actions: {
    handleCreateUser ({
      rootState,
      state,
      commit
    }) {
      commit('setCreateUserDialog')
      commit('openDialog')
    },

    handleDeleteVendor ({
      rootState,
      state,
      commit
    }) {
      commit('setDeleteVendorDialog')
      commit('openDialog')
    },

    async handleUpdateVendor ({
      dispatch,
      rootState,
      commit,
      state
    }) {
      const vendor = state.activeVendor

      commit('setUpdateVendorDialog', { vendor })
      commit('openDialog')
    },
    handleCreateVendor ({
      rootState,
      state,
      commit
    }) {
      if (rootState.user.role !== 'Super Admin' && !state.activeVendor) {
        this.$swal('No active vendor', 'Please select a vendor first!', 'error')
      } else {
        commit('setCreateVendorDialog')
        commit('openDialog')
      }
    },
    refreshPassword ({ commit }) {
      const password = generatePassword()
      commit('setPassword', { password })
    },
    linkDevice ({
      commit,
      state
    }) {
      const deviceIds = state.selectedDevices.map(device => device.id)
      const data = {
        link_type: 'vendor',
        vendor: {
          id: state.subVendor.id,
          type: state.subVendor.type
        },
        devices: deviceIds
      }

      if (process.env.NODE_ENV !== 'production') {
        commit('enableResponseDialog', {
          type: 'success',
          commit
        })
      } else {
        api.post('sub-vendors/link', data)
          .then(() => commit('enableResponseDialog', {
            type: 'success',
            commit
          }))
          .catch(e => commit('enableResponseDialog', {
            type: 'error',
            commit
          }))
      }
    },

    linkEntity ({ commit, state }, { reset }) {
      const entityIds = state.selectedEntities.map(entity => entity.id)
      const data = { entities: entityIds }
      api.put(`businesses/${state.subVendor.id}/link/entities`, data).then(() => {
        reset()
        commit('closeDialog')
      })
    },

    startLoading ({ commit }, { tab }) {
      const status = true
      switch (tab) {
        case 'entities':
          commit('setEntitiesLoading', { status })
          break
        case 'devices':
          commit('setDevicesLoading', { status })
          break
        case 'users':
          commit('setUsersLoading', { status })
          break
      }
    },
    stopLoading ({ commit }, { tab }) {
      const status = false
      switch (tab) {
        case 'entities':
          commit('setEntitiesLoading', { status })
          break
        case 'devices':
          commit('setDevicesLoading', { status })
          break
        case 'users':
          commit('setUsersLoading', { status })
          break
      }
    },
    linkVendor ({ commit }) {
      commit('setLinkVendorDialog')
      commit('openDialog')
    },
  }
}
